module.exports = __webpack_public_path__ + "static/st1-2-804be9c5edc82284cf3c2d940646eab3.jpg";